import { api, apiRequestConfig, globalApiConfig } from 'careand-redux/api/ApiThunks';
import { store } from 'careand-redux/store';
import { getUnwrappedDispatch, UnwrappedAppDispatch } from 'careand-redux/useAppDispatch';
import {
  Configuration,
  DeviceTokenDeviceTypeEnum,
  DeviceTokenTokenTypeEnum,
  NotificationsApi,
} from 'generated/api';
import { request } from 'http';
import { Device } from './Native/Device';

/**
 * Sends Notification/Push/Device token to BE
 * @param tokenOrNone if no token is provided, app will request native app for the current token
 */
export async function updatePushToken(userId?: string, tokenOrNone?: string) {
  const dispatch = getUnwrappedDispatch(store.dispatch);
  const patientId = userId ?? store.getState().authentication.activeUserId;

  if (!patientId) {
    return;
  }
  if (!Device.isMobile()) {
    return;
  }

  const token = tokenOrNone ?? (await Device.requestPushToken());
  if (!token) {
    return;
  }

  if (await Device.isPushTokenSent()) {
    return;
  }

  const res = await dispatch(
    api.Notifications.subscribePatientDevice({
      patientId,
      device_token: {
        token_type: DeviceTokenTokenTypeEnum.Push,
        device_token: token,
        device_type: Device.getDeviceType()!,
      },
    }),
    { meta: true },
  );

  if (res.isSuccess) {
    Device.setPushTokenSent(true);
    console.log('sent push token successfully');
  }
}

export function removePushToken() {
  const dispatch = getUnwrappedDispatch(store.dispatch);
  const storeState = store.getState();
  const patientId = storeState.authentication.activeUserId;
  const authToken = storeState.authentication.token;

  if (!patientId || !Device.isMobile()) {
    return;
  }

  const data = {
    patientId,
    device_token: {
      token_type: DeviceTokenTokenTypeEnum.Push,
      device_token: '',
      device_type: Device.getDeviceType()!,
    },
  };
  let { headers, basePath } = apiRequestConfig.Notifications.unsubscribePatientDevice(data);
  headers = { ...headers, Authorization: `Bearer ${authToken}` };

  Device.requestPushToken()
    .then((pushToken) => {
      if (!pushToken) {
        return;
      }
      data.device_token.device_token = pushToken;
    })
    .then(() =>
      new NotificationsApi(
        new Configuration({
          basePath,
          apiKey: `Bearer ${authToken}`,
          headers,
        }),
      ).unsubscribePatientDevice(data),
    );

  Device.setPushTokenSent(false);
}
